import { PipeTransform, Pipe } from "@angular/core";
import { BillTo } from "../../api/models/bill-to";

@Pipe({
    name: "sortAddress"
})
export class BillToAddressSort implements PipeTransform {
    transform(values: BillTo[], inputAccount: string): BillTo[] {
        const selectedAddress = values.filter(value => value.account === inputAccount);
        const otherAddresss = values.filter(value => value.account !== inputAccount);
        let result = [];
        selectedAddress.forEach(record => result.push(record));
        otherAddresss.forEach(record => result.push(record));
        return result;
    }
    
}


// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/market-edit/bill-to-sort.pipe.ts